"use client"
import React from "react";
import Recruitment1 from "./Recruitment1";
import PageAddListing10 from "./PageAddListing10";
import Recruitment2 from "./Recruitment2";
import Recruitment3 from "./Recruitment3";
import Recruitment4 from "./Recruitment4";
import Recruitment5 from "./Recruitment5";
import Recruitment6 from "./Recruitment6";
import Recruitment7 from "./Recruitment7";
//import PageAddListing3 from "./PageAddListing3";
//import PageAddListing4 from "./PageAddListing4";
//import PageAddListing5 from "./PageAddListing5";
//import PageAddListing6 from "./PageAddListing6";
import PageAddListing7 from "./PageAddListing7";
import PageAddListing8 from "./PageAddListing8";
import PageAddListing9 from "./PageAddListing9";

const Page = ({
  params,
  searchParams,
}: {
  params: { stepIndex: string };
  searchParams?: { [key: string]: string | string[] | undefined };
}) => {
  
  let ContentComponent = Recruitment1;
  
  switch (Number(params.stepIndex)) {
    case 1:
      ContentComponent = Recruitment1;
      break;
    case 2:
      ContentComponent = Recruitment2;
      break;
    case 3:
      ContentComponent = Recruitment3;
      break;
    case 4:
      ContentComponent = Recruitment4;
      break;
    case 5:
      ContentComponent = Recruitment5;
      break;
    case 6:
      ContentComponent = Recruitment6;
      break;
    case 7:
      ContentComponent = Recruitment7;
      break;
    case 8:
      ContentComponent = PageAddListing8;
      break;
    case 9:
      ContentComponent = PageAddListing9;
      break;
    case 10:
      ContentComponent = PageAddListing10;
      break;

    default:
      ContentComponent = Recruitment1;
      break;
  }

  return <ContentComponent />;
};

export default Page;
